<p-sidebar
    id="app-sidebar"
    [visible]="isVisible"
    [showCloseIcon]="false"
    [styleClass]="
        isCollapsed
            ? hasScrollbar
                ? 'app-sidebar collapsed has-scrollbar'
                : 'app-sidebar collapsed'
            : 'app-sidebar expanded'
    "
    position="left"
    [modal]="false"
    [class.disabled-sidebar]="isSidebarDisabled">
    <div id="sidebar-header">
        <a [routerLink]="appRoutes.routes().DASHBOARD">
            <img
                [ngSrc]="'assets/images/app-logo.svg'"
                [alt]="'img.alt.goToDashboard' | translate"
                width="40"
                height="40"
                id="app-logo-sidebar" />
        </a>
        <div>
            <p id="app-title">Sequencing</p>
            <p id="app-subtitle">Transnetyx</p>
        </div>
    </div>

    <div id="sidebar-content">
        <app-navigation [isSidebarCollapsed]="isCollapsed" (toggleIsCollapsed)="toggleIsCollapsed()"></app-navigation>
    </div>

    <div
        id="collapse-area"
        (click)="toggleIsCollapsed()"
        [ngClass]="isCollapsed ? 'collapse-area-c' : 'collapse-area-e'">
        <button pButton class="p-button-rounded p-button-text" aria-label="Toggle sidebar">
            <i class="fa-thin fa-angle-right" [class]="isCollapsed ? 'collapsed' : 'expanded'"></i>
        </button>
    </div>
</p-sidebar>
